import { Component, OnInit, Input } from '@angular/core';
import { CommercialService } from '../../commercial.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
  useAnimation
} from '@angular/animations';

@Component({
  selector: 'app-cq23',
  templateUrl: './cq23.component.html',
  styleUrls: ['./cq23.component.css', '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})
export class Cq23Component implements OnInit {

  @Input() data:any;
  question;
  questions;
  user_bot = false;
  showbutton = true;
  userResponses = [];
  index;
  questionObj;
  deviceWidth;
  question_sub1;
  question_sub2;
  contact_time;
  timer;
  isChecked = false;
  slot1_id;
  slot2_id;
  slot3_id;
  hgTimeSlots = {
    slot1: false,
    slot2: false,
    slot3: false
  };

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.userResponses = this.commercialService.userResponse.userResponses;
    this.deviceWidth = this.commercialService.deviceWidth;
  }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.slot1_id = document.getElementById('slot1_mob');
      this.slot2_id = document.getElementById('slot2_mob');
      this.slot3_id = document.getElementById('slot3_mob');
    } else {
      this.slot1_id = document.getElementById('slot1');
      this.slot2_id = document.getElementById('slot2');
      this.slot3_id = document.getElementById('slot3');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        this.index = i;
        if (this.deviceWidth > 768) {
          const question_sub1 = this.question.split('time ');
          this.question_sub1 = question_sub1[0] + ' time';
          this.question_sub2 = question_sub1[1];
        }
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.contact_time = obj.fieldValue;
        this.isChecked = true;
        if (!_.isEmpty(this.contact_time)) {
          if (this.contact_time === '8am - 11am') {
            this.hgTimeSlots = {
              slot1: true,
              slot2: false,
              slot3: false
            };
            this.slot1_id.parentElement.classList.add('active-select');
          } else if (this.contact_time === '11am - 2pm') {
            this.hgTimeSlots = {
              slot1: false,
              slot2: true,
              slot3: false
            };
            this.slot2_id.parentElement.classList.add('active-select');
          } else if (this.contact_time === '2pm - 6pm') {
            this.hgTimeSlots = {
              slot1: false,
              slot2: false,
              slot3: true
            };
            this.slot3_id.parentElement.classList.add('active-select');
          }
          this.user_bot = true;
          if (this.deviceWidth < 768) {
            this.goNext();
          }
        }
      }
    }

    if(!this.hgTimeSlots.slot1 && !this.hgTimeSlots.slot2 && !this.hgTimeSlots.slot3)
    {
      this.showbutton = false;
    }
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  getTimetoContact(event) {
    this.contact_time = event.target.value;
    this.isChecked = event.target.checked;
    if (this.isChecked === true) {
      if (this.deviceWidth < 768) {
        // // console.log.log(this.deviceWidth);
        this.commercialService.unSelectService({'currentId': this.data});
      }
      if (!_.isEmpty(this.contact_time)) {
        this.user_bot = true;
        if (this.contact_time === '8am - 11am') {
          this.hgTimeSlots = {
            slot1: true,
            slot2: false,
            slot3: false,
          };
          if (_.contains(this.slot2_id.parentElement.classList, 'active-select')) {
            this.slot2_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.slot3_id.parentElement.classList, 'active-select')) {
            this.slot3_id.parentElement.classList.remove('active-select');
          }
          this.slot1_id.parentElement.classList.add('active-select');
        } else if (this.contact_time === '11am - 2pm') {
          this.hgTimeSlots = {
            slot1: false,
            slot2: true,
            slot3: false,
          };
          this.slot2_id.parentElement.classList.add('active-select');
          if (_.contains(this.slot1_id.parentElement.classList, 'active-select')) {
            this.slot1_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.slot3_id.parentElement.classList, 'active-select')) {
            this.slot3_id.parentElement.classList.remove('active-select');
          }
        } else if (this.contact_time === '2pm - 6pm') {
          this.hgTimeSlots = {
            slot1: false,
            slot2: false,
            slot3: true,
          };
          this.slot3_id.parentElement.classList.add('active-select');
          if (_.contains(this.slot1_id.parentElement.classList, 'active-select')) {
            this.slot1_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.slot2_id.parentElement.classList, 'active-select')) {
            this.slot2_id.parentElement.classList.remove('active-select');
          }
        }
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    } else {
      this.hgTimeSlots = {
        slot1: false,
        slot2: false,
        slot3: false,
      };
      if (_.contains(this.slot1_id.parentElement.classList, 'active-select')) {
        this.slot1_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.slot3_id.parentElement.classList, 'active-select')) {
        this.slot3_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.slot2_id.parentElement.classList, 'active-select')) {
        this.slot2_id.parentElement.classList.remove('active-select');
      }
      this.contact_time = '';
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
      this.user_bot = false;
    }
    this.save();

        
    if (this.isChecked === true)
    {
      if (this.deviceWidth < 768) {
       
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
  
      }

    }
  }
  
  next() {
    if (_.isEmpty(this.contact_time)) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
    } else {
      this.commercialService.messageService({ 'currentId': this.data });
    }
  }

  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'com_question_id': this.data, 'fieldName': 'time_to_contact', 'fieldValue': this.contact_time
    };
    this.commercialService.updateResponses(Obj);
  }

}
